export const WEBINARS_DATA = "WEBINARS_DATA";
export const WEBINARS_DATA_LOADING = "WEBINARS_DATA_LOADING";
export const WEBINAR_IS_LOADING = "WEBINAR_IS_LOADING";
export const WEBINAR_LOADED = "WEBINAR_LOADED";
export const WEBINAR = "WEBINAR";
